import { InsurancePolicy } from '../services/departures'

export function calculatePolicyCost (policy: InsurancePolicy, { totalPrice, localCosts }: { totalPrice: number, localCosts: number }): number {
  const insuredPrice = totalPrice - localCosts
  const insuredSubtotal = policy.fixed_cost + (insuredPrice * policy.fee_percentage / 100.0)
  const policyAmount = Math.round(insuredSubtotal * 100) / 100.0
  const policyTax = Math.round(policyAmount * policy.tax_percentage) / 100.0
  return policyAmount + policyTax
}
